// Import SVG as URL
import greshamLogoUrl from './gresham-logo.svg';

// Export logo assets with specific typing
export const GreshamLogo: string = greshamLogoUrl; 